import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const sendConversationsMessage = async (selectedDomain: string, clientId: number, conversationId: number, content: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `conversation/send`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        params: {
            clientId,
            conversationId,
            content,
        },
        isEncrypted: true,
    });
}